import kidInTfdBoxJpg from './kid-in-tfd-box.jpg';
import kidInTfdBoxWebp from './kid-in-tfd-box.webp';

export const imageCardSources = {
  webp: kidInTfdBoxWebp,
  jpg: kidInTfdBoxJpg,
};
